import { DecimalPipe } from '@angular/common';
import { Component, Inject, OnInit, EventEmitter, isDevMode } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AmplifyService } from 'aws-amplify-angular';
import { MaskApplierService, MaskPipe } from 'ngx-mask';
import { Subscription } from 'rxjs';
import { Md5 } from 'ts-md5';
import { AppLoadingService } from '../../services/apploading.service';
import { GeneralService } from '../../services/general.service';
import { SignatureService } from '../../services/signature.service';
import { SignaturePadComponent } from '../signature-pad/signature-pad.component';

declare var $: any;

@Component({
  selector: 'authorization-preview',
  templateUrl: 'authorization-preview.component.html',
  styleUrls: ['./authorization-preview.component.scss']
})
export class AuthorizationPreviewComponent implements OnInit {

  emitter: EventEmitter<any> = new EventEmitter();

  printOpened = false;

  business:any = [ ];

  states: any = [];

  person: any = {};
  owner: any = {};
  requester: any = {};

  init = false;
  modelLoaded = false;

  businessSelected = 0;

  formDisabled = false;

  personData: any = [];

  dataMap:any = {
    EMPRESA_LOGO : '',
    EMPRESA_RAZAOSOCIAL : '',
    EMPRESA_CNPJ : '',

    RESPONSAVEL : '',
    RESPONSAVEL_CPF : '',
    RESPONSAVEL_ASSINATURA : '',

    SOLICITANTE_RAZAOSOCIAL : '',
    SOLICITANTE_CNPJ : '',
    SOLICITANTE_CRECI : '',
    SOLICITANTE_CRECI_ESTADO : '',
    SOLICITANTE_ENDERECO : '',

    DATA : '',
    CODIGO_DOCUMENTO : '',
    PRAZO_DOCUMENTO : '',
    LOGO_CENTRALCORRETOR : '',
  };

  isDev = isDevMode();

  modelContent:string = '';

  modelSelected = 0;

  modelSeted = 0;

  models:any = {};    

  minScale = 0;

  protected personDataSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog,
    protected gs: GeneralService,
    protected ms : MaskApplierService,
    protected signatureService : SignatureService,
    protected as: AmplifyService,
    private als: AppLoadingService
  ) { 

    this.personDataSubscription = this.gs.generalData$.subscribe(async (result) => {
      if (!!result?.person?.length) {
          this.person = result?.person[0];
          
          if(this.modelSeted>0)
            await this.setModelData();
      }
    });
    
  }

  async ngOnInit(){
   
    if(this.data.owner != this.gs.getCompanieSel()){
      this.dialog.getDialogById(this.data.modalId)?.close();
      return;
    }

    this.owner = this.gs.getCompanieData(this.data.owner);
    
    this.requester = this.data.authorization.payload;

    await this.setDefault();
    
  }
  async setDefault(){

    let modelToLoad = null;
  
    if(this.data.authorization.ad_authorization_model){
        modelToLoad = this.gs.getFileName(this.gs.getFileLink(this.data.authorization.ad_authorization_model,0)[0],'original');
    } else if(this.data.authorization.ad_owner_authorization_model){
        modelToLoad = this.gs.getFileName(this.gs.getFileLink(this.data.authorization.ad_owner_authorization_model,0)[0],'original');
    } else if(this.gs.settingsData?.models?.saleAuthorization){
        modelToLoad =  this.gs.settingsData?.models?.saleAuthorization;
    } 

    if(!this.models?.models)
        await this.gs.loadModels('saleauthorization', modelToLoad, async result => { await this.setModelData(result); });
    else
        await this.setModelData();
  }

  async setModel(){
    let model = this.models.models.filter(item => item.id == this.modelSelected)[0];
    this.modelContent = '<style>'+this.models.css+' '+(model?.css || '')+'</style>'
    this.modelContent += model.content;

    this.modelContent = await this.getUrls(this.modelContent);    

    Object.keys(this.dataMap).map(item => {
      this.modelContent = this.modelContent.replace(new RegExp('%'+item+'%', 'g'), this.dataMap[item]);
    });

    if(this.data?.preview=='pdf'){
      this.emitter.emit('<style>.auth-content{width:100% !important;}</style>'+this.modelContent);//'<div class="auth-page print">'++'</div>');
    }

    this.als.setLoaded(true,'setModelData');
  }

  async replaceAsync(str, regex, asyncFn) {
    const promises = [];
    str.replace(regex, (match, ...args) => {
        const promise = asyncFn(match, args);
        promises.push(promise);
    });
    const data = await Promise.all(promises);
    return str.replace(regex, () => data.shift());
  }

  async getUrls(str) {
    var regex = /src\s*=\s*(['"])(https?:\/\/.+?)\1/gi;

    return this.replaceAsync(str, regex, async (url) => {
      url = url.replace(/['"]+/g, '');
        
      let file =  await this.gs.getFile(url, true);
      return " crossorigin='anonymous' src='"+file+"'";

    });

  }

  async setModelData(model = false){
    this.init = true;        

    await this.als.setLoaded(false,'setModelData');

    if(model)
        this.models = model;

    this.modelSeted++;
    let mask = new MaskPipe(this.ms);

    let md5 = new Md5();
 
    md5.appendStr(this.data.authorization.person_request_id)
        .appendStr(this.data.authorization.creator_public_idtext);

    let documentNumber = md5.end();

    let ownerAddressText = [(this.owner?.address_street || '') + (this.owner?.address_number ? ', n ' + this.owner?.address_number : '') + (this.owner?.address_complement ? ' ' + this.owner?.address_complement : ''), this.owner?.address_district, this.owner?.address_city + (this.owner?.address_state_acronym ? ' / ' + this.owner?.address_state_acronym : '')].filter(Boolean).join(' - ');
    let adAddressText = !this.data.authorization?.ad_address_street? '' : [(this.data.authorization?.ad_address_street || '') + (this.data.authorization?.ad_address_number ? ', n ' + this.data.authorization?.ad_address_number : '') + (this.data.authorization?.ad_address_complement ? ' ' + this.data.authorization?.ad_address_complement : ''), this.data.authorization?.ad_address_district, this.data.authorization?.ad_address_city + (this.data.authorization?.ad_address_state_acronym ? ' / ' + this.data.authorization?.ad_address_state_acronym : '')].filter(Boolean).join(' - ');
     
    let comission = new DecimalPipe('pt').transform(this.data.authorization?.ad_commission || '5.0000', '0.2-2');

    this.dataMap = {
      TITULO : this.data.authorization?.ad_incorporation? 'Autorização de venda e divulgação de imóvel' : 'Autorização de divulgação de imóvel',
      TEXTO_VENDA : this.data.authorization?.ad_incorporation? 'venda e ' : '',
      EMPRESA_LOGO : this.owner?.logoFile?.thumb? '<img crossorigin="anonymous" src="'+await this.gs.getFile(this.owner.logoFile.thumb)+'" />' : '',
      EMPRESA_NOME : this.owner?.name,
      EMPRESA_RAZAOSOCIAL : this.owner?.company_name,
      EMPRESA_TIPO_DOCUMENTO : this.owner.document?.replace(/[^0-9]+/g, "")?.length==11? 'CPF' : 'CNPJ',
      EMPRESA_TIPO_PESSOA : this.owner.document?.replace(/[^0-9]+/g, "")?.length==11? 'pessoa física' : 'pessoa jurídica de direito privado',
      EMPRESA_CNPJ : mask.transform(this.owner?.document?.replace(/[^0-9]+/g, "") || '', this.owner.document?.replace(/[^0-9]+/g, "")?.length==11? '999.999.999-99' : '99.999.999/9999-99'),
      EMPRESA_ENDERECO : ownerAddressText,
      EMPRESA_CIDADE : this.owner.address_city,
      EMPRESA_ESTADO : this.owner.address_state_acronym,
      COMISSAO : (this.data?.authorizeData?.comission || comission)+'%',
      RESPONSAVEL : this.person?.person_name || '',
      RESPONSAVEL_TIPO_DOCUMENTO : this.person.document?.replace(/[^0-9]+/g, "")?.length==11? 'CPF' : 'CNPJ',
      RESPONSAVEL_CPF : mask.transform(this.person?.document?.replace(/[^0-9]+/g, "") || '', this.person.document?.replace(/[^0-9]+/g, "")?.length==11? '999.999.999-99' : '99.999.999/9999-99'),
      RESPONSAVEL_ASSINATURA : this.person?.signature? '<img crossorigin="anonymous" src="'+await this.gs.getFile(this.gs.getFileName(this.person.signature, 'original'))+'" />' : '&nbsp;',
      SOLICITANTE_RAZAOSOCIAL : (this.requester.type == '2' && this.data?.authorization?.owner_name? '('+this.data?.authorization?.owner_name+') ' : '') + this.requester.name,
      SOLICITANTE_TIPO_DOCUMENTO : this.requester.document?.replace(/[^0-9]+/g, "")?.length==11? 'CPF' : 'CNPJ',
      SOLICITANTE_CNPJ : mask.transform(this.requester?.document?.replace(/[^0-9]+/g, "") || '', this.requester.document?.replace(/[^0-9]+/g, "")?.length==11? '999.999.999-99' : '99.999.999/9999-99'),
      SOLICITANTE_CRECI : this.requester?.creci  || '',
      SOLICITANTE_CRECI_ESTADO : this.gs.getStates([parseInt(this.requester.creci_state_id)])[0]?.acronym || '',
      SOLICITANTE_ENDERECO : this.requester?.address || '',
      SOLICITANTE_RESPONSAVEL : this.data.authorization.creator_name,
      DATA : new Date().toLocaleDateString('pt-BR',{ month: 'long', day: 'numeric', year: 'numeric' }),
      CODIGO_DOCUMENTO : documentNumber,
      IMOVEL_AUTORIZADO : this.data.authorization.ad_title,
      IMOVEL_ENDERECO : adAddressText,
      IMOVEL_INCORPORACAO : this.data.authorization?.ad_incorporation? 'Incorporação n° '+this.data.authorization?.ad_incorporation : 'disponível apenas para pré-reserva, será disponibilizado à venda após a conclusão da incorporação',
      PRAZO_DOCUMENTO : (this.data?.authorizeData?.expiration?.id > 0? 'de ' : '')+(this.data?.authorizeData?.expiration?.text?.toLowerCase() || 'Indeterminado'),
      LOGO_CENTRALCORRETOR : '<img class="auth-centracorretor-icon" crossorigin="anonymous" src="data:image/png;base64,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"/>'
    };

    await this.setModel();

  }

  print(e,el){
    this.printOpened=true;
    var th = this;
    e.stopPropagation();
    setTimeout(() => 
      $(el).printThis({
        importStyle: true,
        printContainer:false,
        afterPrint: () => { th.printOpened = false; }
    }), 150);
  }

  signature(e){



    let modalId = 'SignaturePadComponent_'+Math.random();
    const dialogRef = this.dialog.open(SignaturePadComponent,
    {   disableClose : true,
        id:modalId,
        data: {
          modalId:modalId,
          person_id : this.person?.person_id,
          file_id : this.person?.signature_file_id
        }
    });
  }
  
}